/* eslint-disable vue/require-v-for-key */
/* eslint-disable vue/require-default-prop */
 <template>
  <div>
    <b-form>
      <b-tabs>
        <b-tab title="Dados Gerais">
          <div class="row">
            <div class="col-md-3">
              <b-form-group
                id="input-group-1"
                label="Nome:"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="produto.nome"
                  type="text"
                  placeholder="Nome do produto"
                  required
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group
                id="input-group-1"
                label="Nome Tecnico:"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="produto.nome_tecnico"
                  type="text"
                  placeholder="Nome tecnico do produto"
                  required
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-2">
              <b-form-group label="Mapa:" label-for="input-1">
                <b-form-input
                  v-model="produto.mapa"
                  type="text"
                  required
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Empresa Registrante" label-for="input-1">
                <v-select
                  class="style-select"
                  :options="empresas"
                  :reduce="(item) => item.id_empresa"
                  label="nome"
                  v-model="produto.id_empresa"
                >
                </v-select>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Classe Toxicológica" label-for="input-1">
                <v-select
                  class="style-select"
                  label="nome"
                  :options="classes_toxicologicas"
                  :reduce="(item) => item.id_classe_toxicologica"
                  v-model="produto.id_classe_toxicologica"
                >
                </v-select>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Classe Produto" label-for="input-1">
                <v-select
                  class="style-select"
                  :options="tipos_produto"
                  label="nome"
                  :reduce="(item) => item.id_tipo_produto"
                  v-model="produto.id_tipo_produto"
                >
                </v-select>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Tipo Formulação" label-for="input-1">
                <v-select
                  class="style-select"
                  label="nome"
                  :options="tipos_formulacao"
                  :reduce="(item) => item.id_tipo_formulacao"
                  v-model="produto.id_tipo_formulacao"
                >
                </v-select>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="EPI:" label-for="input-1">
                <b-form-textarea
                  v-model="produto.desc_epi"
                  no-resize
                  placeholder="Descrição equipamento de proteção individual"
                  required
                  rows="5"
                  max-rows="5"
                ></b-form-textarea>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Antidoto Tratamento:" label-for="input-1">
                <b-form-textarea
                  v-model="produto.desc_antidoto_tratamento"
                  no-resize
                  placeholder="Descrição tratamento"
                  required
                  rows="5"
                  max-rows="5"
                ></b-form-textarea>
              </b-form-group>
            </div>

            <div class="col-md-4">
              <b-form-group label="Incompatibilidade:" label-for="input-1">
                <b-form-textarea
                  v-model="produto.desc_incompatibilidade"
                  no-resize
                  placeholder="Descrição incompatibilidade"
                  required
                  rows="5"
                  max-rows="5"
                ></b-form-textarea>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Precaução uso:" label-for="input-1">
                <b-form-textarea
                  v-model="produto.desc_precaucao_uso"
                  no-resize
                  placeholder="Precaução de uso"
                  required
                  rows="5"
                  max-rows="5"
                ></b-form-textarea>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Primeiros Socorros:" label-for="input-1">
                <b-form-textarea
                  v-model="produto.desc_primeiro_socorro"
                  no-resize
                  placeholder="Descrição primeiros socorros"
                  required
                  rows="5"
                  max-rows="5"
                ></b-form-textarea>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group
                label="Condição Climatica Terrestre:"
                label-for="input-1"
              >
                <b-form-textarea
                  v-model="produto.desc_condicao_climatica_terrestre"
                  no-resize
                  placeholder="Condição Climatica Terrestre"
                  required
                  rows="5"
                  max-rows="5"
                ></b-form-textarea>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group
                label="Condição Climatica Aérea:"
                label-for="input-1"
              >
                <b-form-textarea
                  v-model="produto.desc_condicao_climatica_aerea"
                  no-resize
                  placeholder="Condições climaticas aérea"
                  required
                  rows="5"
                  max-rows="5"
                ></b-form-textarea>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Aplicação terrestre:" label-for="input-1">
                <b-form-textarea
                  v-model="produto.desc_aplicacao_terrestre"
                  no-resize
                  placeholder="Aplicação terrestre"
                  required
                  rows="5"
                  max-rows="5"
                ></b-form-textarea>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Aplicação Aérea:" label-for="input-1">
                <b-form-textarea
                  v-model="produto.desc_aplicacao_aerea"
                  no-resize
                  placeholder="Aplicação Aérea"
                  required
                  rows="5"
                  max-rows="5"
                ></b-form-textarea>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <b-form-group label="MIP:" label-for="input-1">
                <b-form-textarea
                  v-model="produto.desc_mip"
                  no-resize
                  placeholder="MIP"
                  required
                  rows="5"
                  max-rows="5"
                ></b-form-textarea>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <div>
                <div class="row">
                  <div class="col-md-2">
                    <b-form-group label="Código Siagro:" label-for="input-1">
                      <b-form-input
                        v-model="produto.cod_siagro"
                        type="number"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-2">
                    <b-form-group label="Código SIGA:" label-for="input-1">
                      <b-form-input
                        v-model="produto.cod_siga_rs"
                        type="number"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-2">
                    <b-form-group label="Código Sigen:" label-for="input-1">
                      <b-form-input
                        v-model="produto.cod_sigen_sc"
                        type="number"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-2">
                    <b-form-group label="Inflamável:" label-for="input-1">
                      <b-form-checkbox
                        v-model="produto.inflamavel"
                        type="text"
                        required
                      ></b-form-checkbox>
                    </b-form-group>
                  </div>
                  <div class="col-md-2">
                    <b-form-group label="Corrosivo:" label-for="input-1">
                      <b-form-checkbox
                        v-model="produto.corrosivo"
                        type="text"
                        required
                      ></b-form-checkbox>
                    </b-form-group>
                  </div>

                  <div class="col-md-2">
                    <b-form-group label="Ativo:" label-for="input-1">
                      <b-form-checkbox
                        v-model="produto.ativo"
                        type="text"
                        required
                      ></b-form-checkbox>
                    </b-form-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <b-button
            type="submit"
            variant="primary"
            @click.prevent="salvarProduto"
            >Salvar</b-button
          >
        </b-tab>
        <b-tab title="Ingrediente Ativo">
          <div class="row">
            <div class="col-md-4">
              <b-form-group label="Ingrediente ativo" label-for="input-1">
                <v-select
                  class="style-select"
                  label="nome_comum"
                  :options="ingredientes"
                  :reduce="(item) => item.id_ingrediente_ativo"
                  v-model="cadIngrediente.id_ingrediente_ativo"
                >
                </v-select>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Grupo quimico" label-for="input-1">
                <v-select
                  class="style-select"
                  label="nome"
                  :options="quimicos"
                  :reduce="(item) => item.id_grupo_quimico"
                  v-model="cadIngrediente.id_grupo_quimico"
                >
                </v-select>
              </b-form-group>
            </div>
            <div class="col-md-2">
              <b-form-group label="Concentração:" label-for="input-1">
                <b-form-input
                  v-model="cadIngrediente.concetracao"
                  type="number"
                  required
                ></b-form-input>
              </b-form-group>
            </div>
          </div>
          <b-button
            type="submit"
            variant="primary"
            @click.prevent="handleSalvarIngredienteAtivo"
            >Adicionar</b-button
          >
          <div class="row">
            <div class="col-12">
              <b-table
                striped
                hover
                responsive="sm"
                borderless
                bordered
                outlined
                small
                :items="cadingredientes"
                :fields="cadIngredientesFields"
                per-page="10"
              >
                <template v-slot:cell(id_ingrediente_ativo)="row">
                  {{ row.item.id_ingrediente_ativo.nome_comum }}
                </template>
                <template v-slot:cell(id_grupo_quimico)="row">
                  {{ row.item.id_grupo_quimico == undefined ? '' : row.item.id_grupo_quimico.nome }}
                </template>
                <template v-slot:cell(id_produto)="row">
                  {{ row.item.id_produto.nome }}
                </template>
                <template v-slot:cell(actions)="row">
                  <div class="btn-group mb-2">
                    <button
                      v-b-tooltip.hover
                      title="Editar"
                      type="button"
                      class="btn btn-light"
                      @click="cadIngrediente = row.item"
                    >
                      <i class="uil uil-edit"></i>
                    </button>
                    <button
                      v-b-tooltip.hover
                      title="Deletar"
                      type="button"
                      class="btn btn-light"
                      @click="showModalDeleteIngredienteAtivo(row.item)"
                    >
                      <i class="uil uil-trash-alt"></i>
                    </button>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </b-tab>
        <b-tab title="Meio Ambiente">
          <div class="row">
            <div class="col-md-4">
              <b-form-group label="Meio Ambiente" label-for="input-1">
                <v-select
                  class="style-select"
                  label="descricao"
                  :options="meioambientes"
                  :reduce="(item) => item.id_meio_ambiente"
                  v-model="meioAmbiente.id_meio_ambiente"
                >
                </v-select>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <b-form-group label="Frase" label-for="input-1">
                <b-form-textarea
                  v-model="meioAmbiente.desc_frase"
                  no-resize
                  placeholder="Frase de meio ambiente"
                  required
                  rows="5"
                  max-rows="5"
                ></b-form-textarea>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <b-button
                type="submit"
                variant="primary"
                @click.prevent="handleSalvarMeioAmbiente"
                >Adicionar</b-button
              >
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <b-table
                striped
                hover
                responsive="sm"
                borderless
                bordered
                outlined
                small
                :items="cadMeioAmbientes"
                :fields="cadMeioAmbienteFields"
                per-page="30"
              >
                
                <template v-slot:cell(id_meio_ambiente)="row">
                  {{ row.item.id_meio_ambiente.descricao }}
                </template>
                <template v-slot:cell(actions)="row">
                  <div class="btn-group mb-2">
                    <button
                      v-b-tooltip.hover
                      title="Editar"
                      type="button"
                      class="btn btn-light"
                      @click="meioAmbiente = row.item"
                    >
                      <i class="uil uil-edit"></i>
                    </button>
                    <button
                      v-b-tooltip.hover
                      title="Deletar"
                      type="button"
                      class="btn btn-light"
                      @click="showModalDeleteMeioAmbiente(row.item)"
                    >
                      <i class="uil uil-trash-alt"></i>
                    </button>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </b-form>
    <b-modal
      id="modal-delete-cad-ingrediente"
      title="Aviso"
      title-class="font-18"
    >
      <p>Tem certeza que deseja excluir este registro?</p>
      <template v-slot:modal-footer>
        <b-button
          variant="light"
          @click="$bvModal.hide('modal-delete-cad-ingrediente')"
          >Não</b-button
        >
        <b-button variant="danger" @click="handleDeleteCadIngredienteAtivo"
          >Sim</b-button
        >
      </template>
    </b-modal>
    <b-modal
      id="modal-delete-cad-meio-ambiente"
      title="Aviso"
      title-class="font-18"
    >
      <p>Tem certeza que deseja excluir este registro?</p>
      <template v-slot:modal-footer>
        <b-button
          variant="light"
          @click="$bvModal.hide('modal-delete-cad-meio-ambiente')"
          >Não</b-button
        >
        <b-button variant="danger" @click="handleDeleteCadMeioAmbiente"
          >Sim</b-button
        >
      </template>
    </b-modal>
    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </div>
</template>
<script>
import Produto from '@src/services/produto'
import { mask } from 'vue-the-mask'
import Loading from 'vue-loading-overlay'

import ClasseToxicologica from '../services/classe-toxicologica'
import Empresa from '../services/empresa'
import TipoFormulacao from '../services/tipo-formulacao'
import TipoProduto from '../services/tipo-produto'
import ingredienteAtivoService from '../services/ingrediente-ativo'
import grupoQuimicoService from '../services/grupo-quimico'
import cadIngredienteAtivoService from '../services/cad-ingrediente-ativo'
import meioAmbienteService from '../services/meio-ambiente'
import cadMeioAmbienteService from '../services/cad-meio-ambiente'

export default {
  components: {
    Loading,
  },
  directives: { mask },
  props: {
    produto: {},
  },
  data() {
    return {
      show: false,
      mensagems: null,
      sucesso: null,
      classes_toxicologicas: [],
      empresas: [],
      tipos_formulacao: [],
      tipos_produto: [],
      cadingredientes: [],
      quimicos: [],
      ingredientes: [],
      meioambientes: [],
      cadMeioAmbientes:[],
      meioAmbiente: {},
      cadIngrediente: {},
      cadIngredienteSelcted: {},
      cadIngredientesFields: [
        {
          key: 'id_cad_ingrediente_Ativo',
          label: 'ID',
          class: 'size-col-20',
        },
        ,
        {
          key: 'id_ingrediente_ativo',
          label: 'Ingrediente Ativo',
          class: 'size-col-20',
        },
        {
          key: 'id_grupo_quimico',
          label: 'Grupo Quimico',
          class: 'size-col-20',
        },        
        {
          key: 'concetracao',
          label: 'Concetração',
          class: 'size-col-20',
        },
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
      cadMeioAmbienteFields: [
        {
          key: 'id_cad_meio_ambiente',
          label: 'ID',
          class: 'size-col-20',
        },
        {
          key: 'id_meio_ambiente',
          label: 'Frases',
          class: 'size-col-20',
        }, 
        {
          key: 'desc_frase',
          label: 'Descrição',
          class: 'size-col-20',
        },
        
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
      isLoading: false,
    }
  },
  created() {},
  mounted() {
    this.handleGetClasseTox()
    this.handleGetEmpresas()
    this.handleGetTiposFormulacao()
    this.handleGetTiposProduto()
    this.handleGetIngredienteAtivo()
    this.handleGetQuimicos()
    this.handleGetMeioAmbiente()
    this.handleGetIngrediteByProduto()
    this.handleGetMeioAmbienteByProduto()
    this.produto.ativo = this.produto.ativo ? true : false
  },
  methods: {
    loading(a) {
      a = !this.isLoading
      return a
    },
    modalShow() {
      if (this.modal.show === true) {
        this.modal.show = false
      }
    },
    salvarProduto() {
      const token = this.$store.state.auth.currentUser.token
      this.produto.inflamavel =
        this.produto.inflamavel == null ? false : this.produto.inflamavel
      this.produto.corrosivo =
        this.produto.inflamavel == null ? false : this.produto.inflamavel
      if (this.produto.id_produto) {
        this.isLoading = this.loading(this.isLoading)
        Produto.update(token, this.produto)
          .then((resposta) => {
            this.$bvToast.toast('Atualizado com sucesso', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.isLoading = this.loading(this.isLoading)
          })
          .catch((erro) => {
            this.$bvToast.toast(erro.response.data.data.join(', '), {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.isLoading = this.loading(false)
          })
      } else {
        this.isLoading = this.loading(this.isLoading)
        Produto.salvar(token, this.produto)
          .then((resposta) => {
            this.isLoading = this.loading(this.isLoading)
            if (!resposta.data.sucesso) {
              this.$bvToast.toast(resposta.data.mensagem, {
                variant: 'success',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })
            } else {
              this.$bvToast.toast('Salvo com sucesso!', {
                variant: 'success',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })
            }
            this.produto = {}
          })
          .catch((erro) => {
            console.log(erro)
            this.isLoading = this.loading(this.isLoading)
            this.$bvToast.toast(
              erro.response
                ? erro.response.data.data.join(', ')
                : 'Erro inesperado',
              {
                variant: 'danger',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              }
            )
            this.isLoading = this.loading(false)
          })
      }
    },
    handleGetClasseTox() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      ClasseToxicologica.listar(token).then((response) => {
        this.classes_toxicologicas = response.data.dados
        this.isLoading = this.loading(this.isLoading)
      })
    },
    handleGetEmpresas() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      Empresa.listar(token).then((response) => {
        this.empresas = response.data.dados
        this.isLoading = this.loading(this.isLoading)
      })
    },
    handleGetTiposFormulacao() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      TipoFormulacao.listar(token).then((response) => {
        this.tipos_formulacao = response.data.dados
        this.isLoading = this.loading(this.isLoading)
      })
    },
    handleGetTiposProduto() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      TipoProduto.listar(token).then((response) => {
        this.tipos_produto = response.data.dados
        this.isLoading = this.loading(this.isLoading)
      })
    },
    handleGetIngredienteAtivo() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      ingredienteAtivoService.listar(token).then((response) => {
        this.ingredientes = response.data.dados
        this.isLoading = this.loading(this.isLoading)
      })
    },
    handleGetQuimicos() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      grupoQuimicoService.listar(token).then((response) => {
        console.log(response.data.dados)
        this.quimicos = response.data.dados
        this.isLoading = this.loading(this.isLoading)
      })
    },
    handleGetMeioAmbiente() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      meioAmbienteService.listar(token).then((response) => {
        this.meioambientes = response.data.dados
        this.isLoading = this.loading(this.isLoading)
      })
    },
    handleSalvarIngredienteAtivo() {
      if (
        this.cadIngrediente.id_cad_ingrediente_Ativo != undefined &&
        this.cadIngrediente.id_cad_ingrediente_Ativo != 0
      ) {
        this.handleAtualizarIngredienteAtivo()
        return
      }
      this.cadIngrediente.id_produto = this.produto.id_produto
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      cadIngredienteAtivoService
        .salvar(token, this.cadIngrediente)
        .then((response) => {
          this.isLoading = this.loading(this.isLoading)
          this.cadIngrediente = {}
          this.$bvToast.toast(response.data.mensagem, {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          this.handleGetIngrediteByProduto()
        })
        .catch((erro) => {
          this.isLoading = this.loading(this.isLoading)
          this.$bvToast.toast(
            erro.response
              ? erro.response.data.data.join(', ')
              : 'Erro inesperado',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
          this.isLoading = this.loading(false)
        })
    },
    handleAtualizarIngredienteAtivo() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      cadIngredienteAtivoService
        .atualizar(token, this.cadIngrediente)
        .then((response) => {
          this.isLoading = this.loading(this.isLoading)
          this.cadIngrediente = {}
          this.$bvToast.toast(response.data.mensagem, {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          this.handleGetIngrediteByProduto()
        })
        .catch((erro) => {
          this.isLoading = this.loading(this.isLoading)
          this.$bvToast.toast(
            erro.response
              ? erro.response.data.data.join(', ')
              : 'Erro inesperado',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
          this.isLoading = this.loading(false)
        })
    },
    handleGetIngrediteByProduto() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      cadIngredienteAtivoService
        .findByProduto(token, this.produto.id_produto)
        .then((response) => {
          console.log(response.data.dados)
          this.cadingredientes = response.data.dados
          this.isLoading = this.loading(this.isLoading)
        })
    },
    showModalDeleteIngredienteAtivo(ingrediente) {
      this.cadIngredienteSelcted = ingrediente
      this.$bvModal.show('modal-delete-cad-ingrediente')
    },
    handleDeleteCadIngredienteAtivo() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      cadIngredienteAtivoService
        .deletar(token, this.cadIngredienteSelcted.id_cad_ingrediente_Ativo)
        .then((response) => {
          this.isLoading = this.loading(this.isLoading)
          this.$bvToast.toast(response.data.mensagem, {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          this.$bvModal.hide('modal-delete-cad-ingrediente')
          this.handleGetIngrediteByProduto()
        })
        .catch((erro) => {
          this.$bvModal.hide('modal-delete-cad-ingrediente')
          this.isLoading = this.loading(this.isLoading)
          this.$bvToast.toast(
            erro.response
              ? erro.response.data.data.join(', ')
              : 'Erro inesperado',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
          this.isLoading = this.loading(false)
        })
    },

    //cadmeioambiente
    handleSalvarMeioAmbiente() {
      if (
        this.meioAmbiente.id_cad_meio_ambiente != undefined &&
        this.meioAmbiente.id_cad_meio_ambiente != 0
      ) {
        this.handleAtualizarMeioAmbiente()
        return
      }
      this.meioAmbiente.id_produto = this.produto.id_produto
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      cadMeioAmbienteService
        .salvar(token, this.meioAmbiente)
        .then((response) => {
          this.isLoading = this.loading(this.isLoading)
          this.meioAmbiente = {}
          this.$bvToast.toast(response.data.mensagem, {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          this.handleGetMeioAmbienteByProduto()
        })
        .catch((erro) => {
          this.isLoading = this.loading(this.isLoading)
          this.$bvToast.toast(
            erro.response
              ? erro.response.data.data.join(', ')
              : 'Erro inesperado',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
          this.isLoading = this.loading(false)
        })
    },
    handleAtualizarMeioAmbiente() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      cadMeioAmbienteService
        .atualizar(token, this.meioAmbiente)
        .then((response) => {
          this.isLoading = this.loading(this.isLoading)
          this.meioAmbiente = {}
          this.$bvToast.toast(response.data.mensagem, {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          this.handleGetMeioAmbienteByProduto()
        })
        .catch((erro) => {
          this.isLoading = this.loading(this.isLoading)
          this.$bvToast.toast(
            erro.response
              ? erro.response.data.data.join(', ')
              : 'Erro inesperado',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
          this.isLoading = this.loading(false)
        })
    },
    handleGetMeioAmbienteByProduto() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      cadMeioAmbienteService
        .findByProduto(token, this.produto.id_produto)
        .then((response) => {
          this.cadMeioAmbientes = response.data.dados
          this.isLoading = this.loading(this.isLoading)
        })
    },
    showModalDeleteMeioAmbiente(ambiente) {
      this.meioAmbiente = ambiente
      this.$bvModal.show('modal-delete-cad-meio-ambiente')
    },
    handleDeleteCadMeioAmbiente() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      cadMeioAmbienteService
        .deletar(token, this.meioAmbiente.id_cad_meio_ambiente)
        .then((response) => {
          this.meioAmbiente = {}
          this.isLoading = this.loading(this.isLoading)
          this.$bvToast.toast(response.data.mensagem, {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          this.$bvModal.hide('modal-delete-cad-meio-ambiente')
          this.handleGetMeioAmbienteByProduto()
        })
        .catch((erro) => {
          this.$bvModal.hide('modal-delete-cad-ingrediente')
          this.isLoading = this.loading(this.isLoading)
          this.$bvToast.toast(
            erro.response
              ? erro.response.data.data.join(', ')
              : 'Erro inesperado',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
          this.isLoading = this.loading(false)
        })
    },
  },
}
</script>

<style>
</style>